import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../contexts/ApiContext";
import { ReportingMeasurement } from "../shared/interfaces/ReportingMeasurement";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { ReportingPayload } from "../shared/interfaces/ReportingPayload";

export function useAddReportingMeasurements(callbacks?: QueryCallbacks<ReportingPayload>) {
  const apiContext = useContext(ApiContext);

  return useMutation(
    ["addReportingMeasurements"],
    async (reportingMeasurement: ReportingMeasurement) =>
      apiContext.utp2ReportsAPIs.uploadReportMeasurementSelections(reportingMeasurement),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
